import { itemNameMap } from './itemNameMap'
import { FormikErrors } from 'formik'
import { BasicInformationInputInitialValues } from '../../formik/initialValues'
import { CallHistory } from '../../formik/initialValues'

interface Errors {
  item: string
  message: string
}

const createErrorMessage = (formikErrors: FormikErrors<BasicInformationInputInitialValues>) =>{
  const result: Errors[] = [];
  Object.entries(formikErrors).forEach(([itemName, errorMsg]) => {
    if (!Array.isArray(errorMsg)) {
      // エラーメッセージが配列でない場合は、そのままresultにpushする
      result.push({
        item: itemName,
        message: `${itemNameMap[itemName]}${errorMsg}`,
      })
      return;
    }
    // エラーメッセージを配列で持つcallHistoryなどの場合はこちらの処理を通る
    errorMsg.forEach((error: string | FormikErrors<CallHistory>) => {
      if (typeof error !== 'object') return;
      Object.entries(error).forEach(([key, value]) => {
        const itemNameMapChild  = itemNameMap[itemName]
        if (typeof itemNameMapChild !== 'string') {
          result.push({
            item: key,
            message: `${itemNameMapChild[key]}${value}`,
          })
        }
      })
    })
  })
  return result
}

export default createErrorMessage
